import { GridLegacy, IconButton, List, ListItem, TextField, Typography } from "@mui/material";
import React, { useState } from "react";
import Card from "../../../components/Card/Card";
import CardBody from "../../../components/Card/CardBody";
import { useFieldArray, useFormContext } from "react-hook-form";
import TranslationWrapper from "../../../components/TranslationWrapper/TranslationWrapper";
import { Delete } from "@mui/icons-material";
import Button from "../../../components/CustomButtons/Button";

export default function CollectionSettings() {
  const { menukaartVestigingId } = useFormContext();
  return (
    <div style={{ width: "100%", height: "100%" }}>
      {/*<Card>*/}
      {/*  <CardBody style={{ padding: 16 }}>*/}
      {/*    <GridLegacy container spacing={1}>*/}
      {/*        */}
      {/*    </GridLegacy>*/}
      {/*  </CardBody>*/}
      {/*</Card>*/}
      <VoucherCodes />
    </div>
  );
}

function VoucherCodes() {
  const { control } = useFormContext();
  const { fields, append, prepend, remove, swap, move, insert } = useFieldArray({
    control,
    name: "custom_data.collection.voucher_codes",
    // keyName: "key",
  });

  return (
    <Card>
      <CardBody style={{ padding: 16 }}>
        <GridLegacy container spacing={1}>
          <GridLegacy item xs={12}>
            <List
              sx={{
                "& li:nth-child(even)": {
                  backgroundColor: "#eee",
                },
              }}
            >
              <ListItem>
                <GridLegacy container>
                  <GridLegacy item xs={6}>
                    <TranslationWrapper tKey={"Voucher Codes"} />
                  </GridLegacy>
                  <GridLegacy item xs={6} />
                </GridLegacy>
              </ListItem>

              {fields.map((field, index) => {
                return (
                  <ListItem>
                    <GridLegacy container>
                      <GridLegacy item sx={{ display: "grid", alignItems: "center" }} xs={6}>
                        <Typography>{field.voucherCode}</Typography>
                      </GridLegacy>

                      <GridLegacy item xs={6}>
                        <IconButton
                          onClick={() => {
                            remove(index);
                          }}
                        >
                          <Delete />
                        </IconButton>
                      </GridLegacy>
                    </GridLegacy>
                  </ListItem>
                );
              })}
            </List>
          </GridLegacy>
        </GridLegacy>

        <AddChildProduct append={append} />
      </CardBody>
    </Card>
  );
}

function AddChildProduct({ append }) {
  const { register, vestigingId, menukaartVestigingId, reloadDataFromServer } = useFormContext();
  const [value, setValue] = useState("");
  return (
    <>
      <TextField onChange={(e) => setValue(e.target.value)} placeholder={"Enter voucher code"} value={value} />
      <Button
        disabled={!value}
        onClick={() => {
          setValue("");
          append({ voucherCode: value });
        }}
      >
        <TranslationWrapper tKey={"Add voucher code"} />
      </Button>
    </>
  );
}
